import { useWeb3React } from '@web3-react/core';
import { Contract, ethers, Signer } from 'ethers';
import {
  ChangeEvent,
  MouseEvent,
  ReactElement,
  useEffect,
  useState,
  useRef
} from 'react';
import styled from 'styled-components';
import { Provider } from '../utils/provider';
import { Row, Col, Form, Button } from 'react-bootstrap'

//BUSD LIVE
import BUSD_Artifact from '../live_artifacts/contracts/BUSDToken.sol/BUSDToken.json';
import BUSD_Address from '../live_artifacts/contracts/BUSDToken.sol/BUSDToken-address.json';

//CFX LIVE
import CFX_Artifact from '../live_artifacts/contracts/ERC20GameToken.sol/ERC20GameToken.json';
import CFX_Address from '../live_artifacts/contracts/ERC20GameToken.sol/ERC20GameToken-address.json';

//COSMIC LITE NODE LIVE
import CosmicLiteNodeNFTArtifact from '../live_artifacts/contracts/CosmicLiteNodeNFT.sol/CosmicLiteNodeNFT.json';
import CosmicLiteNodeNFTAddress from '../live_artifacts/contracts/CosmicLiteNodeNFT.sol/CosmicLiteNodeNFT-address.json';

//CFALPHA LIVE
import CFALPHA_Artifact from '../live_artifacts/contracts/ERC721GameNFT.sol/ERC721GameNFT.json';
import CFALPHA_Address from '../live_artifacts/contracts/ERC721GameNFT.sol/ERC721GameNFT-address.json';

//CFOG LIVE
import OGNFTArtifact from '../live_artifacts/contracts/OGNFT.sol/OGNFT.json';
import OGNFTAddress from '../live_artifacts/contracts/OGNFT.sol/OGNFT-address.json';

const StyledDeployContractButton = styled.button`
  width: 240px;
  height: 2rem;
  border-radius: 1rem;
  border-color: blue;
  cursor: pointer;
  place-self: center;
`;

const StyledGreetingDiv = styled.div`
  display: grid;
  grid-template-rows: 1fr 1fr 1fr;
  grid-template-columns: 135px 2.7fr 1fr;
  grid-gap: 10px;
  place-self: center;
  align-items: center;
`;

const StyledLabel = styled.label`
  font-weight: bold;
`;

const StyledInput = styled.input`
  padding: 0.4rem 0.6rem;
  line-height: 2fr;
`;

const StyledButton = styled.button`
  width: 150px;
  height: 2rem;
  border-radius: 1rem;
  border-color: blue;
  cursor: pointer;
  place-self: center;
`;

const StyledAppDiv = styled.div`
  display: grid;
  grid-gap: 20px;
`;


export function LiteNodeOwnerApp(): ReactElement {
  return (
    <StyledAppDiv>
      <NFTCreateContract />
    </StyledAppDiv>
  );
}

export function NFTCreateContract(): ReactElement {
  const context = useWeb3React<Provider>();
  const { library, active, account } = context;

  const [signer, setSigner] = useState<Signer>();
  const [NFTContract, setNFTContract] = useState<Contract>();
  const [NFTContractAddr, setNFTContractAddr] = useState<string>('');

  const [image, setImage] = useState('');
  const [price, setPrice] = useState('');
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const reffirstRef = useRef(null);

  const [nftTokenName, setTokenName] = useState<string>('');
  const [nftTokenSymbol, setTokenSymbol] = useState<string>('');
  const [nftTokenOwner, setTokenOwner] = useState<string>('');
  const [approveAmountInput, setApproveAmountInput] = useState<string>('');
  const [buyNODEButton, setBuyNODEButton] = useState<string>('APPROVE BUSD & MINT $COSMICLITENODE NFT');
  const [buyNODECFXButton, setBuyNODECFXButton] = useState<string>('APPROVE CFX & MINT $COSMICLITENODE NFT');

  const [totalBUSDRaised, setTotalBUSDRaised] = useState(0);
  const [totalCFXRaised, setTotalCFXRaised] = useState(0);
  const [busdBalance, setbusdBalance] = useState(0);
  const [safuuBalance, setsafuuBalance] = useState(0);
  const [totalNFTSupply, setTotalNFTSupply] = useState(0);
  const [totalDappNFTSupply, setTotalDappNFTSupply] = useState(0);

  const [nbrAlpha, setNbrAlpha] = useState<string>(''); // Alpha  NFT's
  const [nbrOG, setNbrOG] = useState<string>(''); // OG NFT's

  const [quantity, setQuantity] = useState('1');

  const [transferBUSDAmountInput, setTransferBUSDAmountInput] = useState<string>('');
  const [transferCFXAmountInput, setTransferCFXAmountInput] = useState<string>('');
  
  useEffect((): void => {
    if (!library) {
      setSigner(undefined);
      return;
    }

    setSigner(library.getSigner());
  }, [library]);

  //Because state update is asynchronous we must listen for signer to be updated
  useEffect(() => {
    handleAttachContract();
  }, [signer]);

     //test for account change
     useEffect(() => {
      handleAttachContract();
    }, [account]);

    //test for quantity change
    useEffect(() => {
      handleAttachContract();
    }, [quantity]);

  function handleAttachContract() {

    // only attach when a signer is defined
    if (!signer) {
      return;
    }


    async function attachNFTContract(signer: Signer): Promise<void> {
     
      const NFT = new ethers.ContractFactory(
        CosmicLiteNodeNFTArtifact.abi,
        CosmicLiteNodeNFTArtifact.bytecode,
        signer
      );

      try {
        //NOTE: ALWAYS PRE-DEPLOYED
        //const p2eGameContract = await P2EGame.deploy('Cosmic Force','CFX');
        //await p2eGameContract.deployed();

        const nftContract = await NFT.attach(CosmicLiteNodeNFTAddress.address);
       
        setNFTContract(nftContract);
 
       // window.alert(`P2EGame deployed to: ${p2eGameContract.address}`);

        const tokenName = await nftContract.name();
        const tokenSymbol = await nftContract.symbol();
        const tokenOwner = await nftContract.owner();
        const totalSupply = await nftContract.totalSupply();
        const totalDappMint = await nftContract.totalDappMint();

        setNFTContractAddr(nftContract.address);
        setTokenName(tokenName);
        setTokenSymbol(tokenSymbol);
        setTokenOwner(tokenOwner);
        setTotalNFTSupply(Number(totalSupply));
        setTotalDappNFTSupply(Number(totalDappMint));

        //Chech if BUSD approved and change to MINT buttin if so
        handleCheckApproveBUSD();
        handleCheckApproveCFX();

      } catch (error: any) {
        window.alert(
          'Error!' + (error && error.message ? `\n\n${error.message}` : '')
        );
      }
    }

    attachNFTContract(signer);
  }

  function handleCreateBUSDNFT(event: MouseEvent<HTMLButtonElement>): void {
    event.preventDefault();

    // only attach when a signer is defined
    if (!signer) {
      return;
    }

    async function createNFT(signer: Signer, _quantity: String): Promise<void> {
     
      const NFT = new ethers.ContractFactory(
        CosmicLiteNodeNFTArtifact.abi,
        CosmicLiteNodeNFTArtifact.bytecode,
        signer
      );

      const BUSD = new ethers.ContractFactory(
        BUSD_Artifact.abi,
        BUSD_Artifact.bytecode,
        signer
      );

      try {

        const BUSD_Contract = await BUSD.attach(BUSD_Address.address);

        const amountApproved = await BUSD_Contract.allowance(account, CosmicLiteNodeNFTAddress.address);
        const balanceBUSD = await BUSD_Contract.balanceOf(account);

        var totalCost = 300*Number(_quantity);

        //If not enough allowence left
        if (Number(amountApproved) < (Number(ethers.utils.parseEther(totalCost.toString()))) ) {
          //Do Approve BUSD

        const listingPrice = ethers.utils.parseEther("30000");

        const setTxn = await BUSD_Contract.approve(CosmicLiteNodeNFTAddress.address,listingPrice); // = FFFFetc

        await setTxn.wait();
       
        setBuyNODEButton(`MINT ${_quantity} $COSMICLITENODE NFT(s) WITH ${totalCost} BUSD`);

        window.alert(`BUSD Approve Success!`);

        }

        if(Number(balanceBUSD) < Number(ethers.utils.parseEther(totalCost.toString()))) {
          window.alert('Not enough BUSD balance');
          return;
        }

        const nftContract = await NFT.attach(CosmicLiteNodeNFTAddress.address);
        //const nftMarketplaceContract = await NFTMarketplace.attach(NFTMarketplaceAddress.address);
        const ticker = "BUSD";
        const tickerId = 0;
        const quantity = Number(_quantity);

        const totalDappMintBefore = await nftContract.totalDappMint();
        
        if((Number(totalDappMintBefore) + Number(_quantity)) > 300 ) {
          window.alert('Not enough COSMIC NODE NFTs left to MINT');
          return;
        }
       
        // mint nft 
       // const result2 = await(await nftContract.mint(tickerId, quantity)).wait();

         // mint nft 
         await(await nftContract.mint(tickerId, quantity, {
          gasLimit: Number(_quantity)*380000
      })).wait();


        // get tokenId of new nft 
        //const id = await nftContract.tokenCount();

        const totalSupply = await nftContract.totalSupply();
        setTotalNFTSupply(Number(totalSupply));
        const totalDappMint = await nftContract.totalDappMint();
        setTotalDappNFTSupply(Number(totalDappMint));

        setBuyNODEButton(`MINT ${_quantity} $COSMICLITENODE NFT(s) WITH ${totalCost} BUSD`);
        handleCheckApproveBUSD();

        if (Number(_quantity) == 1) {
          window.alert(`Created $COSMICLITENODE #${totalSupply} NFT`);
        } else {
          window.alert(`Created ${_quantity} $COSMICLITENODE NFTs Last ID: #${totalSupply} `);
        }
        


      } catch (error: any) {
        window.alert(
          'Error!' + (error && error.message ? `\n\n${error.message}` : '')
        );
      }
    }

    createNFT(signer, quantity);
  }

  function handleCreateCFXNFT(event: MouseEvent<HTMLButtonElement>): void {
    event.preventDefault();

    // only attach when a signer is defined
    if (!signer) {
      return;
    }

    async function createNFT(signer: Signer, _quantity: String): Promise<void> {
     
      const NFT = new ethers.ContractFactory(
        CosmicLiteNodeNFTArtifact.abi,
        CosmicLiteNodeNFTArtifact.bytecode,
        signer
      );

      const CFX = new ethers.ContractFactory(
        CFX_Artifact.abi,
        CFX_Artifact.bytecode,
        signer
      );

      try {

        const CFX_Contract = await CFX.attach(CFX_Address.address);
      

        const amountApproved = await CFX_Contract.allowance(account, CosmicLiteNodeNFTAddress.address);
        const balanceCFX = await CFX_Contract.balanceOf(account);

        //************* = 100 with 18 )'s so we can do discount */
        var cost = 100000000000000000000;

        // Discount Implementation
        if (Number(nbrOG) > 0) {
          //Do 35% discount
          cost = (cost / 100) * 65;
        } else if (Number(nbrAlpha) > 0) {
            cost = (cost / 100) * 75;
        }

        var totalCost = (Math.round((cost / 1000000000000000000) * 100) / 100) * Number(_quantity);

        //If not enough allowence left 100000000 = 1000 Safuu
        if (Number(amountApproved) < (Number(ethers.utils.parseEther(totalCost.toString()))) ) {
          //Do Approve CFX

        const listingPrice = ethers.utils.parseEther("30000");

        const setTxn = await CFX_Contract.approve(CosmicLiteNodeNFTAddress.address,listingPrice);

        await setTxn.wait();

        setBuyNODECFXButton(`MINT ${_quantity} $COSMICLITENODE NFT(s) WITH ${totalCost} CFX`);

        window.alert(`CFX Approve Success!`);

        }

        if(Number(balanceCFX) < Number(ethers.utils.parseEther(totalCost.toString()))) {
          window.alert('Not enough CFX balance');
          return;
        }

        const nftContract = await NFT.attach(CosmicLiteNodeNFTAddress.address);
       
        const ticker = "CFX";
        const tickerId = 1;
        const quantity = Number(_quantity);

        const totalDappMintBefore = await nftContract.totalDappMint();
        
        if((Number(totalDappMintBefore) + Number(_quantity)) > 300 ) {
          window.alert('Not enough COSMIC NODE NFTs left to MINT');
          return;
        }

        // mint nft 
        await(await nftContract.mint(tickerId, quantity, {
          gasLimit: Number(_quantity)*380000
      })).wait();
        // get tokenId of new nft 
        //const id = await nftContract.tokenCount();

        const totalSupply = await nftContract.totalSupply();
        setTotalNFTSupply(Number(totalSupply));
        const totalDappMint = await nftContract.totalDappMint();
        setTotalDappNFTSupply(Number(totalDappMint));

        setBuyNODECFXButton(`MINT ${_quantity} $COSMICLITENODE NFT(s) WITH ${totalCost} CFX`);
        handleCheckApproveCFX();

        if (Number(_quantity) == 1) {
          window.alert(`Created $COSMICLITENODE #${totalSupply} NFT`);
        } else {
          window.alert(`Created ${_quantity} $COSMICLITENODE NFTs Last ID: #${totalSupply} `);
        }

      } catch (error: any) {
        window.alert(
          'Error!' + (error && error.message ? `\n\n${error.message}` : '')
        );
      }
    }

    createNFT(signer, quantity);
  }

  function handleCheckApproveBUSD(): void {
   
    // only attach when a signer is defined
    if (!signer) {
      return;
    }

  async function approveCheckBUSD(signer: Signer, _quantity: String): Promise<void> {
      
      //   const BUSDLIVE = new ethers.ContractFactory(
      //     BUSD_LIVEArtifact.abi,
      //     BUSD_LIVEArtifact.bytecode,
      //     signer
      //   );
  
        const BUSD = new ethers.ContractFactory(
          BUSD_Artifact.abi,
          BUSD_Artifact.bytecode,
          signer
        );
  
        try {
  
          const BUSD_Contract = await BUSD.attach(BUSD_Address.address);
            
          const amountApproved = await BUSD_Contract.allowance(account,CosmicLiteNodeNFTAddress.address);
  
          const contractBalanceBUSD = await BUSD_Contract.balanceOf(CosmicLiteNodeNFTAddress.address);     
          const totalRaised = Number(ethers.utils.formatUnits(contractBalanceBUSD,18));
          setTotalBUSDRaised(Math.ceil(totalRaised));
          
    
          const walletNewBalanceBUSD = await BUSD_Contract.balanceOf(account);
          const newBalanceBUSD = Number(ethers.utils.formatUnits(walletNewBalanceBUSD,18));
          setbusdBalance(newBalanceBUSD);

          var totalCost = 300*Number(_quantity);
  
          //OG or ALPHA discount does not apply
          //If not enough allowence left
          if (Number(ethers.utils.formatUnits(amountApproved,18)) >= (totalCost)) {
            setBuyNODEButton(`MINT  ${_quantity} $COSMICLITENODE NFT(s) WITH ${totalCost} BUSD`);
          } else {
            setBuyNODEButton(`APPROVE ${totalCost} BUSD & MINT ${_quantity} $COSMICLITENODE NFT(s)`);
          }
          
        } catch (error: any) {
          window.alert(
            'Error!' + (error && error.message ? `\n\n${error.message}` : '')
          );
        }
      }
  
    approveCheckBUSD(signer, quantity);
  }

  function handleCheckApproveCFX(): void {
   
      // only attach when a signer is defined
      if (!signer) {
        return;
      }
  
      async function approveCheckCFX(signer: Signer, _quantity: String): Promise<void> {
        
        //   const BUSDLIVE = new ethers.ContractFactory(
        //     BUSD_LIVEArtifact.abi,
        //     BUSD_LIVEArtifact.bytecode,
        //     signer
        //   );
    
          const CFX = new ethers.ContractFactory(
            CFX_Artifact.abi,
            CFX_Artifact.bytecode,
            signer
          );

          const ALPHA = new ethers.ContractFactory(
            CFALPHA_Artifact.abi,
            CFALPHA_Artifact.bytecode,
            signer
          );
    
          const OG = new ethers.ContractFactory(
            OGNFTArtifact.abi,
            OGNFTArtifact.bytecode,
            signer
          );
    
          try {

            const CFX_Contract = await CFX.attach(CFX_Address.address);
            const ALPHA_Contract = await ALPHA.attach(CFALPHA_Address.address);
            const OG_Contract = await OG.attach(OGNFTAddress.address);
              
            const amountApproved = await CFX_Contract.allowance(account,CosmicLiteNodeNFTAddress.address);
    
            const contractBalanceCFX = await CFX_Contract.balanceOf(CosmicLiteNodeNFTAddress.address);     
            const totalSafuuRaised = Number(ethers.utils.formatUnits(contractBalanceCFX,18));
            setTotalCFXRaised(Math.ceil(totalSafuuRaised));
            
      
            const walletNewBalanceCFX = await CFX_Contract.balanceOf(account);
            const newBalanceCFX = Number(ethers.utils.formatUnits(walletNewBalanceCFX,18));
            setsafuuBalance(newBalanceCFX);

            //Test if any ALPHA NFT's exist does not use ethes 18 digs
            const walletBalanceCFALPHA = await ALPHA_Contract.balanceOf(account);

            //Test if any ALPHA OG's exist does not use ethes 18 digs
            const walletBalanceOG = await OG_Contract.balanceOf(account);

            //set for later but use direct below
            if (Number(walletBalanceCFALPHA)){
              setNbrAlpha('1'); //Just set to 1 don't need actual total
            } else {
              setNbrAlpha('');
            }

            if (Number(walletBalanceOG)){
              setNbrOG('1');
            } else {
              setNbrOG('');
            }

            //************* = 100 with 18 )'s so we can do discount */
            var cost = 100000000000000000000;

            // Discount Implementation use direct values
            if (Number(walletBalanceOG)) {
              //Do 35% discount
              cost = (cost / 100) * 65;
            } else if (Number(walletBalanceCFALPHA)) {
                cost = (cost / 100) * 75;
            }

            var totalCost = (Math.round((cost / 1000000000000000000) * 100) / 100) * Number(_quantity);
    
            //If not enough allowence left
            if (Number(ethers.utils.formatUnits(amountApproved,18)) >= (totalCost)) {
              setBuyNODECFXButton(`MINT  ${_quantity} $COSMICLITENODE NFT(s) WITH ${totalCost} CFX`);
            } else {
              setBuyNODECFXButton(`APPROVE ${totalCost} CFX & MINT ${_quantity} $COSMICLITENODE NFT(s)`);
            }
            
          } catch (error: any) {
            window.alert(
              'Error!' + (error && error.message ? `\n\n${error.message}` : '')
            );
          }
      }
    
    approveCheckCFX(signer, quantity);
  }

  function handleQuantityChange(_quantity: string): void {
    setQuantity(_quantity);

    //Chech if BUSD approved and change to MINT button if so
    //handleCheckApproveBUSD();
    //handleCheckApproveCFX();

  }
    
  return (
    <>
      
      <div className="container-fluid">
      <div className="row">
        <main role="main" className="col-lg-12 mx-auto" style={{ maxWidth: '1000px' }}>
          <div className="content mx-auto">
            <Row className="g-4">
            <h6 className="p-4 text-center">
            Contract: {NFTContractAddr}
            </h6>
            </Row>
            <Row className="g-4">
            <h1 className="text-center">
            COSMIC LITE NODE NFT
            </h1>
            </Row>
            <Row className="g-4">
            <Col>
            </Col>
            <Col>
            <h4 className="text-center">
              Minted
            </h4>
            </Col>
            <Col>
            <h4 className="text-center">
              Max Supply
            </h4>
            </Col>
            <Col>
            </Col>
          </Row>
          <Row className="g-4">
            <Col>
            </Col>
            <Col>
            <h5 className="text-center">
             {totalDappNFTSupply}
            </h5>
            </Col>
            <Col>
            <h5 className="text-center">
              300
            </h5>
            </Col>
            <Col>
            </Col>
          </Row>
          <div>&nbsp;</div>
            <Row className="g-8">
            <Col>
            </Col>
            <Col className="text-center" style={{ minWidth: '450px' }}>
            <img  src='./images/COSMIC_LITE_NODE_RELEASE.gif' className='img-fluid' alt='...' />
            </Col>
            <Col>
            </Col>
          </Row>
          <Row className="g-4">
            <h5 className="p-4 text-center">
              100 $CFXv1 = 1 $COSMICLITENODE NFT : 300 $BUSD = 1 $COSMICLITENODE NFT
            </h5>
          </Row>
          <Row className="g-4">
            {nbrOG ? (
            <>
            <h6 className="p-2 text-center">
              OG NFT DETECTED - 35% DISCOUNT WILL APPLY WITH CFX PURCHASE
            </h6>
            </>
            ) : (
            <>
             <h6 className="p-2 text-center">
              {nbrAlpha ? 'ALPHA NFT DETECTED - 25% DISCOUNT WILL APPLY WITH CFX PURCHASE' : 'NO ALPHA OR OG NFT DETECTED - NO DISCOUNT WILL APPLY'}
             </h6>
            </>
            )}
          </Row>
          <Row className="g-4">
          <Col>
          </Col>
          <Col>
          </Col>
            <Col>
          <div className="form-group">
            <label htmlFor="exampleFormControlSelect1">Select quantity to MINT</label>
            <select onChange={(e) => handleQuantityChange(e.target.value)} className="form-control" id="FormControlQuantity">
              <option>1</option>
              <option>2</option>
              <option>3</option>
              <option>4</option>
              <option>5</option>
              <option>6</option>
              <option>7</option>
            </select>
          </div>
          <div>&nbsp;</div>
          </Col>
          <Col>
          </Col>
          <Col>
          </Col>
          </Row>
            <Row className="g-4">
            <Col>
            <div className="d-grid px-8">
              <Button onClick={handleCreateCFXNFT} variant="primary" size="lg">
                {buyNODECFXButton}
              </Button>
            </div>
            </Col>
            <Col>
            <div className="d-grid px-8">
              <Button onClick={handleCreateBUSDNFT} variant="primary" size="lg">
                {buyNODEButton}
              </Button>
            </div>
            </Col>
            </Row>
            <div>&nbsp;</div>
            <Row className="g-4">
            <h6 className="p-1 text-center">
            300 $COSMICLITENODE NFTs are on presale. ALPHA 25% or OG 35% discount can be used ONLY when purchasing with $CFX. 1 Million COSMIC Coins will come into existence as rewards to node holders over a 5 year period starting from mainnet launch. Each $COSMICLITENODE NFT will receive 2.38 COSMIC Coins per MONTH plus a share of the COSMIC BLOCKCHAIN Gas Fees. Estimated COSMIC Coin release price between $1 - $3.
            </h6>
            <h6 className="p-1 text-center">
            
            <a href="https://medium.com/cosmic-force/cosmic-blockchain-validator-nodes-176746a17516" target="_blank">Cosmic Blockchain VALIDATOR NODE article</a>
             </h6>
            </Row>
            <div>&nbsp;</div>
            <Row className="g-4">
              <div className="ratio ratio-16x9">
                <iframe src="https://www.youtube.com/embed/VHCCFZ7-gA0?autoplay=1&rel=0&modestbranding=1" title="Cosmic Force node video"  allowFullScreen></iframe>
              </div>
            </Row>
          </div>
        </main>
      </div>
    </div>
    </>
  );
}
